// extracted by mini-css-extract-plugin
var _1 = "Text-moduledisabled__I_WB4";
var _2 = "Text-moduledone__H3wgy";
var _3 = "Text-modulesecondary__pr8vP";
var _4 = "Text-moduletext__Z2j5F";
var _5 = "Text-moduleunread__s_OU0";
export { _1 as "disabled", _2 as "done", _3 as "secondary", _4 as "text", _5 as "unread" }
